package com.essntl.features.area.data.supabase

import com.essntl.features.area.domain.model.AreaModel
import kotlinx.serialization.json.JsonElement
import kotlinx.serialization.json.JsonPrimitive

internal fun AreaModel.toRequestMap(): Map<String, JsonElement> {
    val requestMap = mutableMapOf<String, JsonElement>()
    if (name != null) {
        requestMap["name"] = JsonPrimitive(name)
    }

    countryModel?.let { country ->
        requestMap["country_id"] = JsonPrimitive(if (country.isEmpty) null else country.id)
    }

    return requestMap
}
